import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
const baseStyle = defineStyle({
  fontSize: 'sm',
  requiredIndicator: {
    color: 'KYOTO.dark'
  }
});
export const formLabelTheme = defineStyleConfig({
  baseStyle
});